
/**
 * @description catalog页面内容注册
 */


/************************************** Module ***********************************************/

import angular from "angular";
import "angular-route";

import 'qp-msg-prompt';

import { PageModule } from "../../../modules/main/anonymous-page.module";

import { module_name as qpPictureLoading } from "../../../directives/qp-picture-loading/qp-picture-loading.module";

import { qpTagsModule } from '../../../directives/qp-tags/qp-tages.module';

import { qpTotopModule } from "../../../qp-ui-bootstrap/totop";

import { name as accessor } from "@modules/accessor/accessor.module";

/************************************** Service ***********************************************/

import { CatalogProductRestService } from '@modules/product/catalog-product/rest/catalog-product-rest.service';
import { CatalogProductRestServiceConfig } from '@modules/product/catalog-product/rest/catalog-product-rest.config';
import { AnonymousRestService } from "@modules/user/rest/anonymous-user-rest-service";
import { RestfulAccessorProvider } from "@core/data-access/restful";
import { AnonymousRestServiceConfig } from "@modules/user/rest/anonymous-rest.config";
import { module_name as qpLazyImage } from "@qpUIs/qp-lazy-image/qp-lazy-image.module";
/************************************** Controller ***********************************************/

import { CatalogController } from "./catalog.controller";

import { ProductsController } from './products.controller';

import { NavDrawerController } from '../../../modules/main/header/nav-drawer.controller';

import { FooterPageController } from "@modules/main/footer-page/footerPage.controller";

/***************************************less*****************************************************/
import './style/catalog.less';

/*************************************** class *****************************************************/
import { CatalogObjectTree } from "./catalog-object-tree";
import { envConfig } from "@env/env-config";

/************************************** 内容注册 ***********************************************/

let root = window.location.href.split("customize");

// productModule.name
let productCatalogModule = angular.module("qpmn-catalog", [PageModule.name, qpPictureLoading, "ngRoute", qpTagsModule.name, qpTotopModule.name, accessor, qpLazyImage])

    .controller({
        catalogController: CatalogController,
        productsController: ProductsController,
        navDrawerController: NavDrawerController,
        footerPageController: FooterPageController,
    })
    .constant("pageContext", {
        rootPath: root[0]
    })
    .service({
        $objectTree: CatalogObjectTree,
        anonymousRestService: AnonymousRestService,
        catalogProductRestService: CatalogProductRestService

    })
    .config(["$accessorProvider", function ($accessorProvider: RestfulAccessorProvider) {
        $accessorProvider.config(AnonymousRestServiceConfig);
        $accessorProvider.config(CatalogProductRestServiceConfig);
    }])

    .config(['$routeProvider', '$locationProvider',
        function (
            $routeProvider: angular.route.IRouteProvider,
            $locationProvider: angular.ILocationProvider
        ) {
            $locationProvider.html5Mode({
                enabled: true,
                requireBase: true,
                rewriteLinks: true
            });

            let head = document.head || document.getElementsByTagName('head')[0];
            let script = document.createElement('base');
            let path = window.location.pathname.split("customize");
            script.href = path[0] + "customize";

            head.append(script);

            $routeProvider
                .when("/customize/:parentCatalog/:childCatalog", {
                    templateUrl: 'products.html',
                    controller: 'productsController',
                    controllerAs: "productsCtrl"
                })
                // todo: "/customize/catalog-Clothing/" 这种类型url会一直进入otherwise死循环加载location.href
                // .when("/customize/:parentCatalog/", {
                //     templateUrl: 'products.html', 
                //     controller: 'productsController',
                //     controllerAs: "productsCtrl"
                // })
                .otherwise({
                    template: '<div></div>',
                    controller: ["$window", "$objectTree", function ($window, $objectTree) {
                        //TODO 未找到匹配的类目页时,跳转至首页
                        // $window.location.href = envConfig.getHomePage(this.rootPath);

                        if (!angular.isUndefined($objectTree.urlParameter)) {
                            $window.location.href = window.location.href + $objectTree.urlParameter;
                        } else {
                            $window.location.href = window.location.href;
                        }
                    }]
                });
        }])
    .run(["$templateCache", function ($templateCache) {
        $templateCache.put('products.html', require("../../basic/product/catalog/products/products.ftl").default);
        $templateCache.put('breadcrumb-nav.html', require("../../basic/product/catalog/products/products.ftl").default);
    }])

export { productCatalogModule };